import React, { useState, useEffect } from 'react';

interface DelayGratificationActivityProps {
  timeLeft: number;
  onInteraction: (data: any) => void;
}

export function DelayGratificationActivity({ timeLeft, onInteraction }: DelayGratificationActivityProps) {
  const [waitTime, setWaitTime] = useState(5);
  const [canClick, setCanClick] = useState(false);
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setCanClick(true);
      onInteraction({ type: 'wait_complete', timestamp: Date.now() });
    }, waitTime * 1000);

    return () => clearTimeout(timer);
  }, [waitTime, onInteraction]);

  const handleClick = () => {
    if (canClick && !clicked) {
      setClicked(true);
      onInteraction({ type: 'button_click', success: true, timestamp: Date.now() });
    } else if (!canClick) {
      onInteraction({ type: 'button_click', success: false, timestamp: Date.now() });
    }
  };

  return (
    <div className="text-center">
      <p className="text-lg font-semibold text-orange-700 mb-8 font-baloo">
        Wait for the button to turn green, then click it! ⏰
      </p>
      <button
        onClick={handleClick}
        className={`w-32 h-32 rounded-full text-white font-bold text-xl transition-all duration-300 font-baloo ${
          clicked
            ? 'bg-green-500 scale-110'
            : canClick
            ? 'bg-green-500 hover:bg-green-600 animate-pulse'
            : 'bg-orange-400 cursor-not-allowed'
        }`}
        disabled={clicked}
      >
        {clicked ? '🎉' : canClick ? 'Click Me!' : `Wait... ${Math.max(0, waitTime - Math.floor((Date.now() % 10000) / 1000))}`}
      </button>
      {!canClick && (
        <p className="text-orange-600 mt-4 font-baloo">
          Good things come to those who wait! 🌟
        </p>
      )}
    </div>
  );
}
